module.exports = __webpack_public_path__ + "img/graphique-page-vente@2x.c4cfbf8a.jpg";